import { featuresSelectors } from '../../redux/features/selectors/featuresSelectors.ts';
import { useAppSelector } from '../../redux/hooks.ts';
import { ReconciliationModule } from '../reconciliation/ReconciliationModule.tsx';
import { QualityControlReview } from './QualityControlReview.tsx';

export const ReviewModule = () => {
  const { selectShouldUseAiQualityControlReview } = featuresSelectors;
  const shouldUseAiQualityControlReview = useAppSelector(selectShouldUseAiQualityControlReview);

  if (!shouldUseAiQualityControlReview) {
    return <ReconciliationModule />;
  }

  return <QualityControlReview />;
};
